import { Table } from '../../Table';
import useTable from '../../../hooks/useTable';
import { TableComponentProps } from '../types';

const columnLables = {
  reporting_member_state: {
    name: 'Reporting Member state',
    order: 1,
    disabled: true
  },
  version: {
    name: 'Report Version',
    order: 2,
    disabled: true
  },
  creation_date_time: {
    name: 'Creation date and time',
    order: 3,
    disabled: true
  }
};

export const BasicTable = ({
  funds,
  currentDataKey,
  onChangeFund,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) => {
  const { rows, columns, onChange } = useTable({
    data: funds[currentDataKey]?.fund_data?.HEADER_FILE,
    onChangeFund,
    schema: schema.HEADER_FILE,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.HEADER_FILE?.field_names || [],
    isMultiFunds,
    funds,
    tableName: 'HEADER_FILE',
    columnLables
  });

  return (
    <Table
      id="reporttables-basic-table"
      handleChanges={onChange}
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
      columns={columns}
      rows={rows}
    />
  );
};
